import { useState, useEffect, useCallback } from "react";
import apiClient from "../../../../../application/apis/api-client";
import { ApplicationRemovalTask } from "../../../../../application/domain/application/application-removal-task/application-removal-task";
import { toast } from "react-toastify";
import {
  SmartApplyApiError,
  reportUnexpectedError,
} from "@graffer-inc/smart-apply";
import { Auth } from "../../../../../application/domain/auth/auth";

export const useApplicationRemovalTaskDetail = (id: string, auth: Auth) => {
  const [applicationRemovalTask, setApplicationRemovalTask] = useState<
    ApplicationRemovalTask | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      // 申請削除タスクの参照権限がない場合は、データを取得しない
      if (
        !auth.checkGroupPermissionWithoutTarget([
          "applications.removal_tasks_read",
        ])
      ) {
        return;
      }

      try {
        const { data: task } = await apiClient.getRemovalApplicationTask(id);
        setApplicationRemovalTask(task);
      } catch (error) {
        toast.error("申請削除タスクの取得に失敗しました。");
      }
    })();
  }, [auth, id]);

  const onCancel = useCallback(async () => {
    try {
      setIsLoading(true);
      await apiClient.cancelRemovalApplicationTask(id);
      const { data: task } = await apiClient.getRemovalApplicationTask(id);
      setApplicationRemovalTask(task);
      toast.success("申請削除タスクを中止しました");
    } catch (e) {
      if (SmartApplyApiError.isErrorCode(e, "bad_request.version_outdated")) {
        toast.error(
          "申請削除タスクの中止に失敗しました。画面を更新して再度中止してください。",
        );
        return;
      }
      reportUnexpectedError(e);
      toast.error("申請削除タスクの中止に失敗しました。");
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  return { applicationRemovalTask, onCancel, isLoading };
};
